import React, { useEffect, useState } from "react";
import { Button, Checkbox, FormControlLabel, FormGroup, makeStyles, Switch } from "@material-ui/core";
import { columns } from "./../thead";
import { useDispatch } from "react-redux";
import { actionTypes as actionTypesNotif } from "./../../../../../../../redux/notificationAlert";


let useStyles = makeStyles((theme) => ({
    gridItem: {
        display: 'flex',
        flexDirection: 'row',
        flexWrap: 'wrap',
        justifyContent: 'flex-start',
        alignItems: 'center',
    },
    btnOtlineBlack: {
        fontSize: 14,
        backgroundColor: "white",
        color: "black",
        margin: "0 5px",
        padding: '9px 20px',
        border: `1px solid black`,
        [theme.breakpoints.down("1236")]: {
            padding: '9px 7px',
        },
        '&:hover': {
            backgroundColor: "black",
            color: "white"
        },
        [theme.breakpoints.down("500")]: {
            minWidth: '100% !important',
            marginBottom: '10px',

        },
    },
    openAccountRed: {
        backgroundColor: theme.palette.light.type2,
        color: "white",
        margin: "0 5px",
        padding: '9px 20px',
        border: `1px solid ${theme.palette.light.type2}`,
        fontSize: 14,
        [theme.breakpoints.down("1236")]: {
            padding: '9px 7px',
        },
        '&:hover': {
            backgroundColor: "#ffffff",
            color: theme.palette.light.type2,
            border: `1px solid ${theme.palette.light.type2}`,
        },
        [theme.breakpoints.down("500")]: {
            minWidth: '100% !important',
            width: '100%',
        },
    },
    gridBtns: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        marginTop: '30px',
    }
}))

export default function Index({ data, stock, setStock, setOpen, open }) {

    let classes = useStyles();
    let dispatch = useDispatch();

    const [keySymbol, setKeySymbol] = useState([
        {
            id: "",
            label: "",
        },
    ]);
    const [active, setActive] = useState(true)


    useEffect(() => {
        if (columns?.length && !stock?.[data?.body?.['offer_symbol']]) {
            let arr = columns.map((cell) => ({ ...cell, check: false }))
            setKeySymbol(arr)
        } else {
            if (stock?.[data?.body?.['offer_symbol']]) {
                let arr = stock?.[data?.body?.['offer_symbol']]?.['keys']
                setKeySymbol(arr)
                setActive(stock?.[data?.body?.['offer_symbol']]?.['active'])
            }
        }
    }, []);

    useEffect(() => {
   
    
      return () => {
        
      };
    }, []);
    

    useEffect(() => {
        return () => {
            setKeySymbol([])
        };
    }, []);



    const apiInsertStock = () => {
        setStock((prev) => ({
            ...prev,
            [data?.body?.['offer_symbol']]: {
                keys: keySymbol,
                active: active,
                data: data
            }
        }
        ))
        dispatch({ type: actionTypesNotif.success });
        setOpen(false)
    }


    const handelChange = (idItems , value) => {
        let res = keySymbol.map((cell , ind) => {
            if(cell?.id === idItems){
                return {...cell , check : value}
            }
            return cell
        })
        setKeySymbol(res)
    }


    return (
        <div className={classes['root']}>
            <div className={classes['title']}>
                <h6>
                    <span>

                        نام کارگزاری
                        :
                    </span>
                    <span>
                        {
                            ` ${data?.body?.['offer_symbol']} `
                        }
                    </span>
                </h6>
            </div>
            <hr />
            <div className={classes['gridItem']}>
                {keySymbol
                .filter((cell)=>
                cell?.label === 'قیمت پایانی'||
                cell?.label === 'حجم کالای قابل عرضه'||
                cell?.label === 'قیمت پایه'||
                cell?.label === 'پایین ترین قیمت'||
                cell?.label === 'بالاترین قیمت'
                )
                ?.map((cell, ind) => (
                    <>
                        <FormGroup >
                        <FormControlLabel control={
                        <Checkbox
                            checked={cell?.check}
                            onChange={(e)=>handelChange(cell?.id , e.target.checked)}
                        />
                        }
                            label={cell?.label} />
                    </FormGroup>
                    </>
                ))}
            </div>
            <div className={classes['gridBtns']}>
                <div>
                    <Switch
                        checked={active}
                        onChange={(e) => setActive(e.target.checked)}
                    />
                    {
                        active ? 'فعال' : 'غیر فعال'
                    }
                </div>
                <div>
                    <Button
                        onClick={() => apiInsertStock()}
                        className={classes.btnOtlineBlack}
                    >
                        ثبت
                    </Button>
                    <Button
                        onClick={() => setOpen(false)}
                        className={classes.openAccountRed}
                    >
                        لغو
                    </Button>
                </div>
            </div>
        </div>)
}
